import React from 'react';
import FilteredAutomationList from '../components/FilteredAutomationList';

const AgentCopyMissing = () => {
    const breadcrumbItems = [
        { label: 'Home', href: '/' },
        { label: 'Automation Trigger', href: '/automation' },
        { label: 'Agent Copy Missing', active: true }
    ];

    return (
        <FilteredAutomationList
            completionStatus="agent_copy_missing"
            title="Agent Copy Missing"
            subtitle="Automation runs where agent copy information is missing"
            breadcrumbItems={breadcrumbItems}
        />
    );
};

export default AgentCopyMissing;